import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type { CreateInboxRequestBody } from '@conversed/shared/src/central/dto/inbox.dto';
import type React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';

type Props = {
  inboxData?: Partial<CreateInboxRequestBody>;
  onSubmit: (data: CreateInboxRequestBody) => void;
};

interface IInboxFormData {
  name: string;
}

export const InboxDataModal: React.FC<Props> = ({ inboxData, onSubmit }) => {
  const { t } = useTranslation();

  const { handleSubmit, control } = useForm<IInboxFormData>({
    shouldUseNativeValidation: true,
    defaultValues: inboxData,
  });

  const { hideModal } = useModal();

  const hideAndSubmit = (data: IInboxFormData) => {
    onSubmit(data);
    hideModal();
  };

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='name'
              placeholder={t('settings.inbox.name')}
              label={t('settings.inbox.name')}
              id='name'
              control={control}
              options={{
                required: t('settings.inbox.validation.name'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default InboxDataModal;
